import { Box, Typography } from '@mui/material';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import { isArray } from 'lodash';
import { TournamentTeamPlayerCard } from 'modules/tournaments/components/BracketTournament/TournamentTeams/TournamentTeamPlayerCard';
import React, { FC } from 'react';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';
import { useStyles } from './TournamentMatchTeamsList.styles';

interface TournamentMatchTeamsListProps {
  teams: TournamentTeamEntity[];
  isSinglePlayer: boolean;
}

export const TournamentMatchTeamsList: FC<TournamentMatchTeamsListProps> = ({
  teams,
  isSinglePlayer = false,
}) => {
  const { classes } = useStyles();

  if (!isArray(teams) || !teams.length) {
    return (
      <Box className={classes.placeholder}>
        <EmptyPlaceholder />
      </Box>
    );
  }

  return (
    <>
      {teams.map((team) => (
        <Box key={team.id}>
          <>
            <Box display="flex" pb={1} pt={1}>
              <Typography>{team.name}</Typography>
              <Typography pl={1}>{isSinglePlayer ? 'player' : 'team'}</Typography>
            </Box>
            {team.players.map((player) => (
              <Box key={player.userId} className={classes.card}>
                <TournamentTeamPlayerCard
                  player={player}
                  isConnectionEnabled
                  isStatusEnabled={false}
                  p={1.875}
                />
              </Box>
            ))}
          </>
        </Box>
      ))}
    </>
  );
};
